import { NavLink, Outlet } from 'react-router-dom'

// Sub-tabs inside a project's Accounts area. "Summary" is the existing
// accounts summary; "Income" surfaces the Total-Income drill-down (A20 / #449)
// and "GST" surfaces the side-bifurcated GST reports — Sales GST (output) and
// Purchase GST (input-tax-credit) — landed in #450.
const TABS: Array<{ to: string; label: string; end?: boolean }> = [
  { to: '', label: 'Summary', end: true },
  { to: 'income', label: 'Income' },
  { to: 'gst', label: 'GST' },
  { to: 'labour', label: 'Labour' },
]

export function AccountsLayout() {
  return (
    <div>
      <nav className="mb-5 flex gap-1 border-b border-surface-700">
        {TABS.map((t) => (
          <NavLink
            key={t.label}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              `px-3 py-2 text-sm border-b-2 -mb-px ${
                isActive
                  ? 'border-accent-500 text-accent-400'
                  : 'border-transparent text-surface-400 hover:text-surface-100'
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  )
}
